// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BGMTable-module__font-s-10___Tb5Bk {
  font-size: 10px !important;
}

.BGMTable-module__font-s-12___JEcqo {
  font-size: 12px !important;
}

.BGMTable-module__font-s-13___EuTqb {
  font-size: 13px !important;
}

.BGMTable-module__font-s-14___ipkAv {
  font-size: 14px !important;
}

.BGMTable-module__font-s-15___LSNL6 {
  font-size: 15px !important;
}

.BGMTable-module__font-s-16___PzKKx {
  font-size: 16px !important;
}

.BGMTable-module__font-s-18___QdSXu {
  font-size: 18px !important;
}

.BGMTable-module__font-s-20___WRJKe {
  font-size: 20px !important;
}

.BGMTable-module__font-s-22___SvxH3 {
  font-size: 22px !important;
}

.BGMTable-module__font-s-28___OuRvE {
  font-size: 28px !important;
}

.BGMTable-module__font-w-400___rI0vP {
  font-weight: 400 !important;
}

.BGMTable-module__font-w-500___MDSIB {
  font-weight: 500 !important;
}

.BGMTable-module__font-w-600___HTavz {
  font-weight: 600 !important;
}

.BGMTable-module__font-w-700___ZKtoh {
  font-weight: 700 !important;
}

.BGMTable-module__p-5___McgZN {
  padding: 5px !important;
}

.BGMTable-module__p-12___YtqdD {
  padding: 12px !important;
}

.BGMTable-module__p-16___d3zYk {
  padding: 16px !important;
}

.BGMTable-module__p-30___IRmgr {
  padding: 30px !important;
}

.BGMTable-module__p-b-0___8NjwK {
  padding-bottom: 0 !important;
}

.BGMTable-module__p-b-5___L0nhG {
  padding-bottom: 5px !important;
}

.BGMTable-module__p-b-10___afloM {
  padding-bottom: 10px !important;
}

.BGMTable-module__p-b-12___OqG_I {
  padding-bottom: 12px !important;
}

.BGMTable-module__p-b-16___O4PH6 {
  padding-bottom: 16px !important;
}

.BGMTable-module__p-b-18___hyAS3 {
  padding-bottom: 18px !important;
}

.BGMTable-module__p-b-20___ty4Lh {
  padding-bottom: 20px !important;
}

.BGMTable-module__p-b-25___HYKHr {
  padding-bottom: 25px !important;
}

.BGMTable-module__p-b-30___bQ6rm {
  padding-bottom: 30px !important;
}

.BGMTable-module__p-b-50___YegOS {
  padding-bottom: 50px !important;
}

.BGMTable-module__p-t-0___THkzQ {
  padding-top: 0 !important;
}

.BGMTable-module__p-t-12___Q75HZ {
  padding-top: 12px !important;
}

.BGMTable-module__p-t-16___qCBi4 {
  padding-top: 16px !important;
}

.BGMTable-module__p-t-18___nQqI0 {
  padding-top: 18px !important;
}

.BGMTable-module__p-t-20___gRbK_ {
  padding-top: 20px !important;
}

.BGMTable-module__p-t-30___LBmbC {
  padding-top: 30px !important;
}

.BGMTable-module__p-t-40___lQVpN {
  padding-top: 40px !important;
}

.BGMTable-module__p-t-50___XKSHO {
  padding-top: 50px !important;
}

.BGMTable-module__p-l-20___HnTZb {
  padding-left: 20px !important;
}

.BGMTable-module__p-l-30___RrH3z {
  padding-left: 30px !important;
}

.BGMTable-module__p-l-40___AHDll {
  padding-left: 40px !important;
}

.BGMTable-module__p-r-16___oCEhp {
  padding-right: 16px !important;
}

.BGMTable-module__p-r-20___pbSMc {
  padding-right: 20px !important;
}

.BGMTable-module__p-r-30___r6KgD {
  padding-right: 30px !important;
}

.BGMTable-module__p-r-50___KrlIe {
  padding-right: 50px !important;
}

.BGMTable-module__p-r-60___X8MTe {
  padding-right: 60px !important;
}

.BGMTable-module__m-b-1___M6yPv {
  margin-bottom: 1px !important;
}

.BGMTable-module__m-b-2___lPvDr {
  margin-bottom: 2px !important;
}

.BGMTable-module__m-b-6___zKnxu {
  margin-bottom: 6px !important;
}

.BGMTable-module__m-b-8___EWjqR {
  margin-bottom: 8px !important;
}

.BGMTable-module__m-b-10___mDGT9 {
  margin-bottom: 10px !important;
}

.BGMTable-module__m-b-14___UvggB {
  margin-bottom: 14px !important;
}

.BGMTable-module__m-b-16___Ca9wL {
  margin-bottom: 16px !important;
}

.BGMTable-module__m-b-20___iQWXJ {
  margin-bottom: 20px !important;
}

.BGMTable-module__m-b-22____VJnz {
  margin-bottom: 22px !important;
}

.BGMTable-module__m-b-24___ozl5U {
  margin-bottom: 24px !important;
}

.BGMTable-module__m-b-30___IZsVt {
  margin-bottom: 30px !important;
}

.BGMTable-module__m-b-32___BygZw {
  margin-bottom: 32px !important;
}

.BGMTable-module__m-b-40___Y_ekO {
  margin-bottom: 40px !important;
}

.BGMTable-module__m-t-2____G5mY {
  margin-top: 2px !important;
}

.BGMTable-module__m-t-3___mA7cM {
  margin-top: 3px !important;
}

.BGMTable-module__m-t-4___tGSZA {
  margin-top: 4px !important;
}

.BGMTable-module__m-t-5___islTe {
  margin-top: 5px !important;
}

.BGMTable-module__m-t-8___tPZKD {
  margin-top: 8px !important;
}

.BGMTable-module__m-t-10___VocWL {
  margin-top: 10px !important;
}

.BGMTable-module__m-t-15___SSUYd {
  margin-top: 15px !important;
}

.BGMTable-module__m-t-16___WXnlI {
  margin-top: 16px !important;
}

.BGMTable-module__m-t-20___mn4zr {
  margin-top: 20px !important;
}

.BGMTable-module__m-t-22___w1JKU {
  margin-top: 22px !important;
}

.BGMTable-module__m-t-30___Vr568 {
  margin-top: 30px !important;
}

.BGMTable-module__m-t-32___ktbGG {
  margin-top: 32px !important;
}

.BGMTable-module__m-l-auto___lYD98 {
  margin-left: auto !important;
}

.BGMTable-module__m-l-4___SkdSv {
  margin-left: 4px !important;
}

.BGMTable-module__m-l-5___QH69h {
  margin-left: 5px !important;
}

.BGMTable-module__m-l-6___xXmzg {
  margin-left: 6px !important;
}

.BGMTable-module__m-l-8___lHVMK {
  margin-left: 8px !important;
}

.BGMTable-module__m-l-10___VUQC6 {
  margin-left: 10px !important;
}

.BGMTable-module__m-l-16___oqVQo {
  margin-left: 16px !important;
}

.BGMTable-module__m-l-20___jnz18 {
  margin-left: 20px !important;
}

.BGMTable-module__m-l-24___OO8g7 {
  margin-left: 24px !important;
}

.BGMTable-module__m-l-30___MN8zI {
  margin-left: 30px !important;
}

.BGMTable-module__m-l-35___UboMc {
  margin-left: 35px !important;
}

.BGMTable-module__m-l-40___JNyoH {
  margin-left: 40px !important;
}

.BGMTable-module__m-r-8___Nuarj {
  margin-right: 8px !important;
}

.BGMTable-module__m-r-10___b1Mw1 {
  margin-right: 10px !important;
}

.BGMTable-module__m-r-16___da_JD {
  margin-right: 16px !important;
}

.BGMTable-module__m-r-20___fli9T {
  margin-right: 20px !important;
}

.BGMTable-module__m-r-24___UJfCf {
  margin-right: 24px !important;
}

.BGMTable-module__m-r-30___jmuob {
  margin-right: 30px !important;
}

.BGMTable-module__m-r-40___e1IdC {
  margin-right: 40px !important;
}

.BGMTable-module__border-r-3___UtERg {
  border-radius: 3px !important;
}

.BGMTable-module__border-r-4___bgvfc {
  border-radius: 4px !important;
}

.BGMTable-module__border-r-6___Mm2df {
  border-radius: 6px !important;
}

.BGMTable-module__border-r-10___U37bp {
  border-radius: 10px !important;
}

.BGMTable-module__border-r-12___bleOT {
  border-radius: 12px !important;
}

.BGMTable-module__border-r-16___j_xGP {
  border-radius: 16px !important;
}

.BGMTable-module__border-r-50___vknzZ {
  border-radius: 50% !important;
}

.BGMTable-module__primary-border___tA14X {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMTable-module__primary-border-b___jeCEO {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMTable-module__primary-border-t___y3fDj {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMTable-module__primary-border-l___I33fA {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMTable-module__primary-border-r___CaaWW {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMTable-module__secondary-border___jBZBp {
  border: 1px solid #637768;
}

.BGMTable-module__secondary-border-b___vtxNa {
  border-bottom: 1px solid #637768;
}

.BGMTable-module__secondary-border-t___f9LWY {
  border-top: 1px solid #637768;
}

.BGMTable-module__secondary-border-l___ZuTnl {
  border-left: 1px solid #637768;
}

.BGMTable-module__secondary-border-r___UGApa {
  border-right: 1px solid #637768;
}

.BGMTable-module__gap-0___RSbD2 {
  gap: 0 !important;
}

.BGMTable-module__gap-2___dtIVm {
  gap: 2px !important;
}

.BGMTable-module__gap-4___bHUNQ {
  gap: 4px !important;
}

.BGMTable-module__gap-5___ayX2e {
  gap: 5px !important;
}

.BGMTable-module__gap-6___x8GlE {
  gap: 6px !important;
}

.BGMTable-module__gap-8___vaSUJ {
  gap: 8px !important;
}

.BGMTable-module__gap-10___w6Fcg {
  gap: 10px !important;
}

.BGMTable-module__gap-12___d8RQf {
  gap: 12px !important;
}

.BGMTable-module__gap-14___Np5Kb {
  gap: 14px !important;
}

.BGMTable-module__gap-16___GBd13 {
  gap: 16px !important;
}

.BGMTable-module__gap-18___v5YE0 {
  gap: 18px !important;
}

.BGMTable-module__gap-20___Yvbbs {
  gap: 20px !important;
}

.BGMTable-module__gap-24___Vej0i {
  gap: 24px !important;
}

.BGMTable-module__gap-26___krdoL {
  gap: 26px !important;
}

.BGMTable-module__gap-30___JdELy {
  gap: 30px !important;
}

.BGMTable-module__gap-32___sIMQW {
  gap: 32px !important;
}

.BGMTable-module__gap-40___TNT05 {
  gap: 40px !important;
}

.BGMTable-module__gap-50___TmtMH {
  gap: 50px !important;
}

.BGMTable-module__flex-1___PGJnq {
  flex: 1;
}

.BGMTable-module__flex-none___RpCh6 {
  flex: none !important;
}

.BGMTable-module__flex-column___xNAD9 {
  display: flex;
  flex-direction: column !important;
}

.BGMTable-module__flex-row___mDUe5 {
  display: flex;
  flex-direction: row !important;
}

.BGMTable-module__vertically-centered___Y0vZN {
  display: flex;
  align-items: center !important;
}

.BGMTable-module__horizontally-centered___gXfyk {
  display: flex;
  justify-content: center !important;
}

.BGMTable-module__horizontally-end___fIR40 {
  display: flex;
  justify-content: end !important;
}

.BGMTable-module__vertically-start___wYelT {
  display: flex;
  align-items: start !important;
}

.BGMTable-module__space-between___p6Ezo {
  display: flex;
  justify-content: space-between !important;
}

.BGMTable-module__flex-wrap___VU6AH {
  flex-wrap: wrap !important;
}

.BGMTable-module__height-100___HET5r {
  height: 100%;
}

.BGMTable-module__width-50___UPxzz {
  width: 50% !important;
}

.BGMTable-module__width-100___ANz1_ {
  width: 100%;
}

.BGMTable-module__cursor-pointer___ZR7vM {
  cursor: pointer;
}

.BGMTable-module__cursor-not-allowed___vrRza {
  cursor: not-allowed !important;
}

.BGMTable-module__absolute-centered___LEKrY {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.BGMTable-module__absolute___AigF_ {
  position: absolute;
}

.BGMTable-module__relative___pR5rl {
  position: relative;
}

.BGMTable-module__fixed___PcGZg {
  position: fixed;
}

.BGMTable-module__visible___wilQS {
  opacity: 1;
}

.BGMTable-module__invisible___F5U20 {
  opacity: 0;
}

.BGMTable-module__col-90___MykWm {
  width: 90% !important;
}

.BGMTable-module__col-auto___bXuw5 {
  width: auto !important;
}

.BGMTable-module__medical-tabs____djNU {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.BGMTable-module__medical-table-new____PfzZ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BGMTable-module__medical-table-new____PfzZ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BGMTable-module__medical-table-new____PfzZ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BGMTable-module__medical-table-new____PfzZ::-webkit-scrollbar-track {
  display: none;
}
.BGMTable-module__medical-table-new____PfzZ.BGMTable-module__no-pagination___zuCMJ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BGMTable-module__medical-table-new____PfzZ.BGMTable-module__no-pagination___zuCMJ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BGMTable-module__medical-table-new____PfzZ.BGMTable-module__no-pagination___zuCMJ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BGMTable-module__medical-table-new____PfzZ.BGMTable-module__no-pagination___zuCMJ::-webkit-scrollbar-track {
  display: none;
}

.BGMTable-module__medical-table-empty___hTYkI {
  padding: 14px 40px !important;
}

.BGMTable-module__icon-btn___IksZm {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.BGMTable-module__search-icon___RbYBk {
  width: 24px;
  height: 24px;
  align-self: center;
}

.BGMTable-module__disable-select___ONC9R {
  user-select: none;
}

.BGMTable-module__break-word___vAB73 {
  word-break: break-word;
}

.BGMTable-module__popup-clear-btn___rjvuH {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.BGMTable-module__scroll-m-b-20___68eHe {
  scroll-margin-bottom: 20px;
}

.BGMTable-module__table___dgqpt {
  margin: 50px 0 0 30px;
  width: 95%;
}
.BGMTable-module__table___dgqpt .BGMTable-module__header___cYlkR {
  display: grid;
  column-gap: 10px;
  padding-bottom: 8px;
  grid-template-columns: 160px repeat(24, minmax(40px, 70px));
}
.BGMTable-module__table___dgqpt .BGMTable-module__header___cYlkR .BGMTable-module__title___jvo1l {
  color: #375844;
}
.BGMTable-module__table___dgqpt .BGMTable-module__header___cYlkR .BGMTable-module__column___phuYP {
  color: #859989;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/tables/BGMTable/BGMTable.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,qBAAA;EACA,UAAA;AA8pBF;AA5pBE;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,2DAAA;AA8pBJ;AA5pBI;EACE,cAAA;AA8pBN;AA3pBI;EACE,cAAA;AA6pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.table {\n  margin: 50px 0 0 30px;\n  width: 95%;\n\n  .header {\n    display: grid;\n    column-gap: 10px;\n    padding-bottom: 8px;\n    grid-template-columns: 160px repeat(24, minmax(40px, 70px));\n\n    .title {\n      color: get-color(greenNew, dark);\n    }\n\n    .column {\n      color: get-color(greenNew, medium);\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `BGMTable-module__font-s-10___Tb5Bk`,
	"fontS12": `BGMTable-module__font-s-12___JEcqo`,
	"fontS13": `BGMTable-module__font-s-13___EuTqb`,
	"fontS14": `BGMTable-module__font-s-14___ipkAv`,
	"fontS15": `BGMTable-module__font-s-15___LSNL6`,
	"fontS16": `BGMTable-module__font-s-16___PzKKx`,
	"fontS18": `BGMTable-module__font-s-18___QdSXu`,
	"fontS20": `BGMTable-module__font-s-20___WRJKe`,
	"fontS22": `BGMTable-module__font-s-22___SvxH3`,
	"fontS28": `BGMTable-module__font-s-28___OuRvE`,
	"fontW400": `BGMTable-module__font-w-400___rI0vP`,
	"fontW500": `BGMTable-module__font-w-500___MDSIB`,
	"fontW600": `BGMTable-module__font-w-600___HTavz`,
	"fontW700": `BGMTable-module__font-w-700___ZKtoh`,
	"p5": `BGMTable-module__p-5___McgZN`,
	"p12": `BGMTable-module__p-12___YtqdD`,
	"p16": `BGMTable-module__p-16___d3zYk`,
	"p30": `BGMTable-module__p-30___IRmgr`,
	"pB0": `BGMTable-module__p-b-0___8NjwK`,
	"pB5": `BGMTable-module__p-b-5___L0nhG`,
	"pB10": `BGMTable-module__p-b-10___afloM`,
	"pB12": `BGMTable-module__p-b-12___OqG_I`,
	"pB16": `BGMTable-module__p-b-16___O4PH6`,
	"pB18": `BGMTable-module__p-b-18___hyAS3`,
	"pB20": `BGMTable-module__p-b-20___ty4Lh`,
	"pB25": `BGMTable-module__p-b-25___HYKHr`,
	"pB30": `BGMTable-module__p-b-30___bQ6rm`,
	"pB50": `BGMTable-module__p-b-50___YegOS`,
	"pT0": `BGMTable-module__p-t-0___THkzQ`,
	"pT12": `BGMTable-module__p-t-12___Q75HZ`,
	"pT16": `BGMTable-module__p-t-16___qCBi4`,
	"pT18": `BGMTable-module__p-t-18___nQqI0`,
	"pT20": `BGMTable-module__p-t-20___gRbK_`,
	"pT30": `BGMTable-module__p-t-30___LBmbC`,
	"pT40": `BGMTable-module__p-t-40___lQVpN`,
	"pT50": `BGMTable-module__p-t-50___XKSHO`,
	"pL20": `BGMTable-module__p-l-20___HnTZb`,
	"pL30": `BGMTable-module__p-l-30___RrH3z`,
	"pL40": `BGMTable-module__p-l-40___AHDll`,
	"pR16": `BGMTable-module__p-r-16___oCEhp`,
	"pR20": `BGMTable-module__p-r-20___pbSMc`,
	"pR30": `BGMTable-module__p-r-30___r6KgD`,
	"pR50": `BGMTable-module__p-r-50___KrlIe`,
	"pR60": `BGMTable-module__p-r-60___X8MTe`,
	"mB1": `BGMTable-module__m-b-1___M6yPv`,
	"mB2": `BGMTable-module__m-b-2___lPvDr`,
	"mB6": `BGMTable-module__m-b-6___zKnxu`,
	"mB8": `BGMTable-module__m-b-8___EWjqR`,
	"mB10": `BGMTable-module__m-b-10___mDGT9`,
	"mB14": `BGMTable-module__m-b-14___UvggB`,
	"mB16": `BGMTable-module__m-b-16___Ca9wL`,
	"mB20": `BGMTable-module__m-b-20___iQWXJ`,
	"mB22": `BGMTable-module__m-b-22____VJnz`,
	"mB24": `BGMTable-module__m-b-24___ozl5U`,
	"mB30": `BGMTable-module__m-b-30___IZsVt`,
	"mB32": `BGMTable-module__m-b-32___BygZw`,
	"mB40": `BGMTable-module__m-b-40___Y_ekO`,
	"mT2": `BGMTable-module__m-t-2____G5mY`,
	"mT3": `BGMTable-module__m-t-3___mA7cM`,
	"mT4": `BGMTable-module__m-t-4___tGSZA`,
	"mT5": `BGMTable-module__m-t-5___islTe`,
	"mT8": `BGMTable-module__m-t-8___tPZKD`,
	"mT10": `BGMTable-module__m-t-10___VocWL`,
	"mT15": `BGMTable-module__m-t-15___SSUYd`,
	"mT16": `BGMTable-module__m-t-16___WXnlI`,
	"mT20": `BGMTable-module__m-t-20___mn4zr`,
	"mT22": `BGMTable-module__m-t-22___w1JKU`,
	"mT30": `BGMTable-module__m-t-30___Vr568`,
	"mT32": `BGMTable-module__m-t-32___ktbGG`,
	"mLAuto": `BGMTable-module__m-l-auto___lYD98`,
	"mL4": `BGMTable-module__m-l-4___SkdSv`,
	"mL5": `BGMTable-module__m-l-5___QH69h`,
	"mL6": `BGMTable-module__m-l-6___xXmzg`,
	"mL8": `BGMTable-module__m-l-8___lHVMK`,
	"mL10": `BGMTable-module__m-l-10___VUQC6`,
	"mL16": `BGMTable-module__m-l-16___oqVQo`,
	"mL20": `BGMTable-module__m-l-20___jnz18`,
	"mL24": `BGMTable-module__m-l-24___OO8g7`,
	"mL30": `BGMTable-module__m-l-30___MN8zI`,
	"mL35": `BGMTable-module__m-l-35___UboMc`,
	"mL40": `BGMTable-module__m-l-40___JNyoH`,
	"mR8": `BGMTable-module__m-r-8___Nuarj`,
	"mR10": `BGMTable-module__m-r-10___b1Mw1`,
	"mR16": `BGMTable-module__m-r-16___da_JD`,
	"mR20": `BGMTable-module__m-r-20___fli9T`,
	"mR24": `BGMTable-module__m-r-24___UJfCf`,
	"mR30": `BGMTable-module__m-r-30___jmuob`,
	"mR40": `BGMTable-module__m-r-40___e1IdC`,
	"borderR3": `BGMTable-module__border-r-3___UtERg`,
	"borderR4": `BGMTable-module__border-r-4___bgvfc`,
	"borderR6": `BGMTable-module__border-r-6___Mm2df`,
	"borderR10": `BGMTable-module__border-r-10___U37bp`,
	"borderR12": `BGMTable-module__border-r-12___bleOT`,
	"borderR16": `BGMTable-module__border-r-16___j_xGP`,
	"borderR50": `BGMTable-module__border-r-50___vknzZ`,
	"primaryBorder": `BGMTable-module__primary-border___tA14X`,
	"primaryBorderB": `BGMTable-module__primary-border-b___jeCEO`,
	"primaryBorderT": `BGMTable-module__primary-border-t___y3fDj`,
	"primaryBorderL": `BGMTable-module__primary-border-l___I33fA`,
	"primaryBorderR": `BGMTable-module__primary-border-r___CaaWW`,
	"secondaryBorder": `BGMTable-module__secondary-border___jBZBp`,
	"secondaryBorderB": `BGMTable-module__secondary-border-b___vtxNa`,
	"secondaryBorderT": `BGMTable-module__secondary-border-t___f9LWY`,
	"secondaryBorderL": `BGMTable-module__secondary-border-l___ZuTnl`,
	"secondaryBorderR": `BGMTable-module__secondary-border-r___UGApa`,
	"gap0": `BGMTable-module__gap-0___RSbD2`,
	"gap2": `BGMTable-module__gap-2___dtIVm`,
	"gap4": `BGMTable-module__gap-4___bHUNQ`,
	"gap5": `BGMTable-module__gap-5___ayX2e`,
	"gap6": `BGMTable-module__gap-6___x8GlE`,
	"gap8": `BGMTable-module__gap-8___vaSUJ`,
	"gap10": `BGMTable-module__gap-10___w6Fcg`,
	"gap12": `BGMTable-module__gap-12___d8RQf`,
	"gap14": `BGMTable-module__gap-14___Np5Kb`,
	"gap16": `BGMTable-module__gap-16___GBd13`,
	"gap18": `BGMTable-module__gap-18___v5YE0`,
	"gap20": `BGMTable-module__gap-20___Yvbbs`,
	"gap24": `BGMTable-module__gap-24___Vej0i`,
	"gap26": `BGMTable-module__gap-26___krdoL`,
	"gap30": `BGMTable-module__gap-30___JdELy`,
	"gap32": `BGMTable-module__gap-32___sIMQW`,
	"gap40": `BGMTable-module__gap-40___TNT05`,
	"gap50": `BGMTable-module__gap-50___TmtMH`,
	"flex1": `BGMTable-module__flex-1___PGJnq`,
	"flexNone": `BGMTable-module__flex-none___RpCh6`,
	"flexColumn": `BGMTable-module__flex-column___xNAD9`,
	"flexRow": `BGMTable-module__flex-row___mDUe5`,
	"verticallyCentered": `BGMTable-module__vertically-centered___Y0vZN`,
	"horizontallyCentered": `BGMTable-module__horizontally-centered___gXfyk`,
	"horizontallyEnd": `BGMTable-module__horizontally-end___fIR40`,
	"verticallyStart": `BGMTable-module__vertically-start___wYelT`,
	"spaceBetween": `BGMTable-module__space-between___p6Ezo`,
	"flexWrap": `BGMTable-module__flex-wrap___VU6AH`,
	"height100": `BGMTable-module__height-100___HET5r`,
	"width50": `BGMTable-module__width-50___UPxzz`,
	"width100": `BGMTable-module__width-100___ANz1_`,
	"cursorPointer": `BGMTable-module__cursor-pointer___ZR7vM`,
	"cursorNotAllowed": `BGMTable-module__cursor-not-allowed___vrRza`,
	"absoluteCentered": `BGMTable-module__absolute-centered___LEKrY`,
	"absolute": `BGMTable-module__absolute___AigF_`,
	"relative": `BGMTable-module__relative___pR5rl`,
	"fixed": `BGMTable-module__fixed___PcGZg`,
	"visible": `BGMTable-module__visible___wilQS`,
	"invisible": `BGMTable-module__invisible___F5U20`,
	"col90": `BGMTable-module__col-90___MykWm`,
	"colAuto": `BGMTable-module__col-auto___bXuw5`,
	"medicalTabs": `BGMTable-module__medical-tabs____djNU`,
	"medicalTableNew": `BGMTable-module__medical-table-new____PfzZ`,
	"noPagination": `BGMTable-module__no-pagination___zuCMJ`,
	"medicalTableEmpty": `BGMTable-module__medical-table-empty___hTYkI`,
	"iconBtn": `BGMTable-module__icon-btn___IksZm`,
	"searchIcon": `BGMTable-module__search-icon___RbYBk`,
	"disableSelect": `BGMTable-module__disable-select___ONC9R`,
	"breakWord": `BGMTable-module__break-word___vAB73`,
	"popupClearBtn": `BGMTable-module__popup-clear-btn___rjvuH`,
	"scrollMB20": `BGMTable-module__scroll-m-b-20___68eHe`,
	"table": `BGMTable-module__table___dgqpt`,
	"header": `BGMTable-module__header___cYlkR`,
	"title": `BGMTable-module__title___jvo1l`,
	"column": `BGMTable-module__column___phuYP`
};
module.exports = ___CSS_LOADER_EXPORT___;
